import classNames from "classnames"

import UsersIcon from "./Icons/UsersIcon"
import Typography from "./Typography"

import { Color } from "@constants/V2/color"
import { useCountUpOnView } from "@hooks/V2/useCountUpOnView"
import useSiteTrustedValues from "@hooks/V2/useSiteTrustedValues"
import { formatTrustedCount } from "@hooks/V2/useTrustedByText"
import React from "react"

interface Props {
  durationMs?: number
  className?: string
}

const TrustedStamp = ({ durationMs = 2000, className }: Props) => {
  const {
    trustedByNumBusinesses: { value: trustedByNumBusinesses, suffix },
  } = useSiteTrustedValues()
  const { intersectionElementRef, displayedValue } = useCountUpOnView(
    trustedByNumBusinesses ?? 0,
    durationMs
  )

  if (trustedByNumBusinesses === undefined) return null

  return (
    <div ref={intersectionElementRef} className={classNames(className)}>
      <Typography
        text="Trusted by"
        size="body-sm"
        font="grotesk"
        color={Color.Black}
        weight="book"
      />

      <div className="flex flex-row gap-8">
        <UsersIcon />

        <Typography
          text={formatTrustedCount(displayedValue, suffix)}
          size="lead-sm"
          weight="medium"
          font="grotesk"
          color={Color.Black}
          className="mt-auto w-96"
        />

        <Typography
          text=" Growing Businesses"
          size="body-md"
          weight="medium"
          font="grotesk"
          color={Color.Black}
          className="mb-[2px] mt-auto"
        />
      </div>
    </div>
  )
}

export default TrustedStamp
